export const getOtpEnabledFromEnv = (): boolean => process.env.NEXT_PUBLIC_OTP_ENABLED === 'true';